export default "__VITE_ASSET__DKwakvBU__"